/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from './api';

/** Get remaining quota + tier info for the current professional. */
export const getInviteQuota = async () => (await api.get('/invite-codes/quota')).data;

/** Generate one or more codes (pro only). */
export const generateInviteCodes = async (count = 1, note = null) =>
  (await api.post('/invite-codes/generate', { count, note })).data;

/** List codes I created + aggregated stats. */
export const listMyInviteCodes = async () => (await api.get('/invite-codes/my')).data;

/** Redeem a code (patient side). */
export const redeemInviteCode = async (code) =>
  (await api.post('/invite-codes/redeem', { code })).data;

/** Validate a code without redeeming (patient side). */
export const validateInviteCode = async (code) =>
  (await api.post('/invite-codes/validate', { code })).data;
